import { Grid, Typography } from '@mui/material'
import React from 'react'

type SectionFixPropsType = {
  title: string
  html: string
}

export const InfoSectionFix = (props: SectionFixPropsType) => {
  return (
    <>
      <Typography className='titleHover'>
        <b>{props.title}</b>
      </Typography>
      <Grid container>
      <Grid xs={12} item>
      <hr />
        <div
          className='area'
          dangerouslySetInnerHTML={{ __html: props.html }}
        ></div>
      </Grid>
      </Grid>
    </>
  )
}
